export const ROUTING_NUMBER_FAQ_EXPAND_PARAM = 'routing-number';

export const ROUTING_NUMBER_FAQ_QUESTION = `What if the company doesn't recognize the Fruitful routing number?`;
